import React, { useEffect, useMemo } from 'react'
import Button from 'shared/components/Button'
import { smartSort } from 'shared/helpers/arrays'
import RoomModal from './components/RoomModal'
import RoomItemModal from './components/RoomItem'

const modals = {
  ROOM_ADD: 'ROOM_ADD',
  ITEM_ADD: 'ITEM_ADD',
  ITEM_EDIT: 'ITEM_EDIT',
}

function ItemsTable({ pack, onDataChange }) {
  const [modalShown, setModalShown] = React.useState(null)
  const [modalData, setModalData] = React.useState(null)

  useEffect(() => {
    if (!modalShown) {
      setModalData(null)
    }
  }, [modalShown])

  const rooms = useMemo(() => {
    if (pack) {
      return pack.room_classifications.map((r) => ({
        id: r.room_classification.id,
        name: r.room_classification.classification_name,
        categories: r.categories ? r.categories.split(',').map((i) => i.trim()) : [],
        weight: r.room_classification.weight,
        //TODO : Discuss, this is empty in the response, no assets to find count in room classification
        package_assets: r.package_assets,
      }))
    }
    return []
  }, [pack])

  const roomCategories = useMemo(() => {
    if (rooms) {
      return rooms.reduce((acc, item) => {
        return {
          ...acc,
          [item.id]: item.categories.map((cat) => ({
            name: cat,
            count: item.package_assets.filter((i) => i.category?.category_name === cat)?.count,
            room: item,
          })),
        }
      }, {})
    }
    return []
  }, [rooms])

  const maxCategoriesLength =
    Object.keys(roomCategories).length > 0 ? Math.max(...Object.values(roomCategories).map((i) => i.length)) : 0

  return (
    <div>
      <div className="my-[16px] flex items-center justify-between">
        <div className="font-medium opacity-70">
          Package content ({maxCategoriesLength > 10 ? '10+' : maxCategoriesLength} pieces)
        </div>
        <div className="flex items-center">
          <Button
            size="small"
            className="ml-[16px] first:ml-[0]"
            variant="secondary"
            rounded
            onClick={() => {
              setModalShown(modals.ROOM_ADD)
            }}
          >
            Add
          </Button>
        </div>
      </div>
      {rooms.length > 0 && (
        <div className="data-table">
          <table className="table table-fixed w-full">
            <thead>
              <tr>
                {rooms.sort(smartSort('weight', 'desc')).map((i, index) => (
                  <th key={index} className="px-4 py-2">
                    <div className="flex justify-between items-center">
                      {i.name}
                      <button
                        type="button"
                        onClick={() => {
                          setModalData({ room: i })
                          setModalShown(modals.ITEM_ADD)
                        }}
                      >
                        +
                      </button>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array(maxCategoriesLength)
                .fill()
                .map((_d, index) => (
                  <tr key={index}>
                    {Object.values(rooms)
                      .sort(smartSort('room_classification.weight', 'desc'))
                      .map((i) => roomCategories[i.id][index])
                      .map((i) => (
                        <td
                          key={index}
                          className={`px-4 py-2  ${i ? 'hover:bg-[#E8EAF0]' : 'pointer-events-none cursor-default'}`}
                          onClick={() => {
                            // onItemClick(i)
                          }}
                        >
                          <button
                            onClick={() => {
                              setModalData({ room: i.room, category: i.name })
                              setModalShown(modals.ITEM_EDIT)
                            }}
                            className=" flex justify-between font-normal text-[12px] w-full"
                          >
                            <span className="underline mr-3 font-semibold ">{i?.name}</span>
                            {i?.count && <span>Qty: {i?.count}</span>}
                          </button>
                        </td>
                      ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
      {modalShown === modals.ROOM_ADD && (
        <RoomModal
          onSuccess={() => {
            setModalShown(false)
            onDataChange()
          }}
          onClose={() => {
            setModalShown(false)
          }}
          existingRooms={rooms}
          pack={pack}
        />
      )}
      {modalShown === modals.ITEM_ADD && (
        <RoomItemModal
          onSuccess={() => {
            setModalShown(false)
            onDataChange()
          }}
          onClose={() => {
            setModalShown(false)
          }}
          pack={pack}
          {...modalData}
        />
      )}
      {modalShown === modals.ITEM_EDIT && (
        <RoomItemModal
          onSuccess={() => {
            setModalShown(false)
            onDataChange()
          }}
          onClose={() => {
            setModalShown(false)
          }}
          pack={pack}
          edit
          {...modalData}
        />
      )}
    </div>
  )
}

export default ItemsTable
